// extracted by mini-css-extract-plugin
export default {"root":"IconCross_root__5nnaO"};